import type { AuthenticationPasswordRequestData } from "../../schemas";
import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";

import { LoginPasswordForm } from "./login-password-form";

export interface LoginPasswordTemplateProps {
	readonly onSubmit: (data: AuthenticationPasswordRequestData) => void;
	readonly defaultUsername: string;
	readonly isError: boolean;
	readonly isSsoError: boolean;
}

export const LoginPasswordTemplate: React.FC<LoginPasswordTemplateProps> = ({
	onSubmit,
	defaultUsername,
	isError,
	isSsoError,
}) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<LoginPasswordForm
					onSubmit={onSubmit}
					defaultUsername={defaultUsername}
					isError={isError}
					isSsoError={isSsoError}
				/>
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
